var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container"},[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"widget-box",domProps:{"innerHTML":_vm._s(_vm.store.privacy)}})]),_vm._v(" "),_c('aside',{staticClass:"sidebar"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-heading"},[_c('h1',[_vm._v("Privacy and Cookies")])])
}]

export { render, staticRenderFns }